import { render } from "./Search.vue?vue&type=template&id=50d4aefd&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=50d4aefd&scoped=true&lang=css"

import exportComponent from "D:\\JOSE\\Escritorio\\Proyectos VUE\\canal-denuncias\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d4aefd"]])

export default __exports__